import { supertypeClass, property } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { RiskFactors } from './RiskFactors';
import { Customer } from './Customer';
import { SpeedingTicket as GQLSpeedingTicket } from '@hit/hit-api-client';

@supertypeClass({ toClient: true, toServer: true })
export class SpeedingTicket extends Everything implements GQLSpeedingTicket {
  @property({ getType: () => RiskFactors })
  riskFactors: RiskFactors;

  @property({ rule: ['required'], values: ['true', 'false'], descriptions: { true: 'Yes', false: 'No' } })
  mvSpeeding15Over: boolean;

  @property({
    rule: ['required'],
    values: ['0-1years', '1-2years', '2-3years', '3-5years'],
    descriptions: {
      '0-1years': '0-1 years',
      '1-2years': '1-2 years',
      '2-3years': '2-3 years',
      '3-5years': '3-5 years',
    },
  })
  mvSpeedingDate: string;

  @property({ getType: () => Customer })
  customer: Customer;

  constructor() {
    super();
  }

  static new(customer: Customer): SpeedingTicket {
    return new SpeedingTicket().init(customer);
  }

  init(customer: Customer): this {
    this.customer = customer;
    return this;
  }
}
